import { mutationRemove, type RemoveHookResponse } from '../hooks'
import { useTantalimMutation } from '../mutation'
import { useProgramCache } from './cache'
import { toResponseError, type ProgramRemoveInput, type ProgramRemoveSuccess } from '@terros/common'

export function useRemoveProgram(): RemoveHookResponse<ProgramRemoveInput> {
  const mutation = useTantalimMutation<ProgramRemoveInput, ProgramRemoveSuccess>({
    url: '/program/remove',
  })
  const cache = useProgramCache()

  async function remove(input: ProgramRemoveInput): Promise<void> {
    try {
      await mutation.mutateAsync(input)
      cache.clearList()
      cache.clearItem(input.programId)
    } catch (error) {
      throw toResponseError(error)
    }
  }

  return mutationRemove(mutation, remove)
}
